import { gql } from '@apollo/client';

// Step 1 — read-only lookup. Resolves the shared meter's primary vendor and
// how much percentage remains available for a Counter Party (CIB) vendor.
export const COUNTER_PARTY_LOOKUP = gql`
  query CounterPartyLookup($meterNumber: String!, $percentage: Float!) {
    counterPartyLookup(meterNumber: $meterNumber, percentage: $percentage) {
      meterId
      meterNumber
      meterName
      primaryVendorId
      primaryVendorName
      existingSecondaryVendorId
      existingSecondaryVendorName
      existingCibPercentage
      remainingPercentage
      cibPercentage
      primaryVendorPercentage
    }
  }
`;

// Step 2 — persists ipp_master.is_counter_party / shared_meter_number /
// cib_percentage on the Counter Party vendor and meter_master.secondary_ipp_id
// on the shared meter, in a single transaction.
export const SAVE_COUNTER_PARTY_METER = gql`
  mutation SaveCounterPartyMeter(
    $ippId: Int!
    $meterNumber: String!
    $percentage: Float!
    $secondaryIppGl: GlInput
  ) {
    saveCounterPartyMeter(
      ippId: $ippId
      meterNumber: $meterNumber
      percentage: $percentage
      secondaryIppGl: $secondaryIppGl
    ) {
      meterId
      meterNumber
      meterName
      primaryVendorId
      primaryVendorName
      remainingPercentage
      cibPercentage
      primaryVendorPercentage
      percentageChangeDeferred
      percentageEffectiveMonth
    }
  }
`;

// Used by the "Add a new Co-party" blade to prefill its read-only Meter
// Number field, and by VendorForm to gate the "Add a new Co-party" button
// and show the read-only "Percentage Payable to Primary Vendor" field.
export const VENDOR_CO_PARTY_INFO = gql`
  query VendorCoPartyInfo($vendorId: Int!) {
    vendorCoPartyInfo(vendorId: $vendorId) {
      eligible
      meterNumber
      hasCoParty
      coPartyVendorId
      coPartyVendorName
      coPartyType
      percentagePayableToPrimaryVendor
    }
  }
`;
